'use client';

export function useHasProPlan() {
	return {
		hasProPlan: true,
		isCanceled: false,
		isLoading: false,
		subscription: {
			status: 'active',
			cancelAtPeriodEnd: false,
			stripePriceId: null as string | null,
			currentPeriodEnd: null as string | null,
		},
		hasStripeCustomer: false,
	};
}
